import { render, staticRenderFns } from "./my-channel.vue?vue&type=template&id=de1b5eee&scoped=true&"
import script from "./my-channel.vue?vue&type=script&lang=js&"
export * from "./my-channel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1b5eee",
  null
  
)

export default component.exports